import React, { useState,useContext } from 'react'
import { PeFilterContext } from "../../../Contexts/PeFilterContext";
import Card from '../../../Components/Advisor/AdvisorPageCard/Card'
import Layout from '../../../Components/VC/VcLAdvisorLayout'
import MainMenu from '../../../Components/VC/LegalMainmenu'
// import RefineSearch from '../../../Components/RefineSearch'
import Table from '../../../Components/Advisor/TableComponent'
import FilterTag from '../../../Components/Tag'
import RefineSearch from '../../../Components/RefineSearchComponent'
import AdvisorExistsRefineSearch from '../../../Components/RefineSearch/AdvisorExistsRefineSearch'
import {PE_TABLE_QUERY} from '../../../Queries/Pe';
import ChatIcon from '../../../images/Group 13/png/Group 13.png';
import chatPopupIcon from '../../../images/chatPopupIcon.png'
import ChatPopup from '../../../Components/ChatPopup'
import Constants from '../../../Constants'
import { useLocation } from 'react-router-dom'

/* The `Advisor` function is a React component that renders the advisor page. */
function Advisor() { 
    const [showModal, setShowModal] = React.useState(false);
    const location = useLocation();
    const {refineSearchFilters} = useContext(PeFilterContext);

    const { pathname } = useLocation(); 
      const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false

    return (
        <>
        <Layout active={4}>
                <div className="flex h-screen flex-col">
                    {/* Top nav*/}
                    {isFromGlobalSearch() ? "" :    <div className="hidden lg:block"> <Card /></div>}
                    {/* Bottom section */}
                    <div className="flex min-h-0 flex-1 overflow-hidden">
                        {/* Narrow sidebar*/}
                        {/* Main area */}
                        <main className= {isFromGlobalSearch() ? "mt-[3rem] min-w-0 flex-1 border-t border-gray-200 lg:flex":"min-w-0 flex-1 border-t border-gray-200 lg:flex"}>
                            {/* Primary column */}
                            <section
                                className="flex h-full min-w-0 flex-1 flex-col overflow-y-auto lg:order-last bg-[#EDEDED]"
                            >
                                {/* Your content */}
                                <FilterTag menu ="advisor-exit-pm-vc" />                                
                                <MainMenu type="vc_pm_exit" active={2} menu="advisor" subMenu ="exist-pm-pm" primaryTypeMasterId={Constants.primaryMasterIds.vcId}
                                subTypeMasterId={Constants.primaryMasterSubIds.vc_advisors_pm_id}
                                typeId={Constants.moduleIds.l_advisor_id}
                                exportFileName={Constants.exportNames.vc_l_advisor_exit_pm} advisor_type="L"/>
                                
                                <div className='overflow-y-auto'>
                                    <Table menu ="vc_pm_advisor" advisor_type="L"  sub_type_master_id={Constants.subCategoryIds.vc_ladvisor_exitspm_id}/>
                                    </div>                                   
                            </section>
                            {/* Secondary column (hidden on smaller screens) */}
                            <aside className="hidden lg:order-first lg:block lg:flex-shrink-0">
                                <div className="relative flex flex-col border-r border-gray-200 bg-[#FAF5EA]">
                                    {/* Your content */}
                                    <RefineSearch> <AdvisorExistsRefineSearch customPathname={location.pathname}/> </RefineSearch>
                                </div>
                            </aside>
                        </main>
                    </div>                    
                </div>
            </Layout>
        </>
    )
}

export default Advisor
